module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGe26f3fbb88a0d576fb75870d838da5fe.e26f3fbb.png";